
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-14714.59 16988.256 17.316 14.525"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Symbol 205 – 16"}},[_c('g',{attrs:{"data-name":"Group 8332"}},[_c('path',{attrs:{"d":"M-14710.809 16996.099l3.979-3.98a4.02 4.02 0 0 1 5.692-.054 4.036 4.036 0 0 1 0 5.747l-3.979 3.979","data-name":"Path 3676","fill":"none","stroke":"#2386db","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.4"}}),_c('path',{attrs:{"d":"M-14711.515 16992.45l-.9 4.994a.249.249 0 0 0 .264.264l5.074-.98c.291-.027.478-.478.346-.61l-4.094-4.094a.546.546 0 0 0-.69.425z","data-name":"Path 3677","fill":"#2386db"}})])])])
          )
        }
      }
    